/*
 * @Author: your name
 * @Date: 2021-08-20 12:06:25
 * @LastEditTime: 2022-04-19 18:08:27
 * @LastEditors: Please set LastEditors
 * @Description: 全局配置
 * @FilePath: \Reptilec:\Users\Administrator\Desktop\data\vue-element-ui-admin\src\main.js
 */
import Vue from "vue";
import App from "./App.vue";
import elementUi from "element-ui";
import Config from "@/config/app";
import "@/assets/css/style.scss";
import router from "./router";
import store from "./store";
import "@/utils/v-auth.js";
import { getToken } from "@/utils/common";
import "./components";

// import "./components/v-page/index.js";
Vue.config.productionTip = false;
Vue.prototype.GlobalCfg = Config;
Vue.use(elementUi);
Vue.prototype.$eventBus = new Vue();

// 文件上传组件
import uploader from "vue-simple-uploader";
Vue.use(uploader);



router.beforeEach((to, from, next) => {
  store.commit("BUILD_ROUTES_CHAIN", to);
  window.document.title = to.meta.title
    ? to.meta.title + "-" + Config.siteName
    : Config.siteName;
  if (!getToken() && to.path !== "/login") {
    next({
      path: "/login"
    });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

if (window.console) {
  var cons = console;
  if (cons) {
    // cons.log("%c\n       ", "font-size:41px;background:url('http://cdn.iknow.bdimg.com/static/common/pkg/module_zed9cd9fd.png') no-repeat -135px -1px");
    // cons.log('想和我们共同打造世界最大中文互动问答平台吗？\n想让自己的成就在亿万用户面前展现吗？想让世界看得你的光芒吗？\n加入我们，在这里不仅是工作，投入你的时间和热情，滴滴汗水终会汇聚成不平凡的成果。\n期待你的加盟。（投简历地址被我砍了）');
    cons.log(
      "%c个人博客： https://qiuhc.gitee.io",
      "color:red;font-weight:bold;"
    );
  }
}
